"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importDefault(require("react"));

var SvgContrast = function SvgContrast(props) {
  return react_1.default.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24'
  }, props), react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    id: 'contrast_svg__a',
    d: 'M12 20V4c4.411 0 8 3.588 8 8s-3.589 8-8 8m0-18C6.486 2 2 6.485 2 12c0 5.514 4.486 10 10 10s10-4.486 10-10c0-5.515-4.486-10-10-10'
  })), react_1.default.createElement("use", {
    xlinkHref: '#contrast_svg__a'
  }));
};

exports.default = SvgContrast;